import { mode, orient, multiStyleConfig } from "@chakra-ui/theme-tools";
var slider = multiStyleConfig({
  parts: {
    container: "the slider wrapper",
    thumb: "the slider thumb or handle",
    track: "the slider outer track",
    filledTrack: "the slider inner/filled track"
  },
  baseStyle: function baseStyle(props) {
    return {
      container: Object.assign({
        _disabled: {
          opacity: 0.6,
          cursor: "default",
          pointerEvents: "none"
        }
      }, orient({
        orientation: props.orientation,
        vertical: {
          height: "100%"
        },
        horizontal: {
          width: "100%"
        }
      })),
      track: {
        borderRadius: "sm",
        bg: "gray.400",
        _disabled: {
          bg: "gray.300"
        }
      },
      thumb: Object.assign({
        zIndex: 1,
        borderRadius: "full",
        bg: "teal.200",
        boxShadow: "sm",
        border: "1px solid",
        borderColor: "transparent",
        transition: "transform 0.2s",
        _focus: {
          boxShadow: "outline"
        },
        _disabled: {
          bg: "gray.300"
        }
      }, orient({
        orientation: props.orientation,
        vertical: {
          left: "50%",
          transform: "translateX(-50%)"
        },
        horizontal: {
          top: "50%",
          transform: "translateY(-50%)"
        }
      })),
      filledTrack: {
        bg: mode(props.colorScheme + ".500", props.colorScheme + ".200")(props)
      }
    };
  },
  sizes: {
    md: function md(props) {
      return {
        thumb: {
          width: "20px",
          height: "20px"
        },
        track: orient({
          orientation: props.orientation,
          horizontal: {
            height: "4px"
          },
          vertical: {
            width: "4px"
          }
        })
      };
    },
    sm: function sm(props) {
      return {
        thumb: {
          width: "10px",
          height: "10px"
        },
        track: orient({
          orientation: props.orientation,
          horizontal: {
            height: "2px"
          },
          vertical: {
            width: "2px"
          }
        })
      };
    }
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export default slider;